import React from 'react'
import { useState } from 'react'
import {Link} from 'react-router-dom'   // import Link from 'react-router-dom'

const CartTotal = ({data, value}) => {

    const[changeAddress, setChangeAddress] = useState(false);

return (
<div className="flex flex-col w-full border-2 border-light-gray md:p-4 p-2 ">
    <div className="flex md:flex-row flex-col lg:space-x-4 mt-4 justify-between border-b-2 border-slate-300">
            <p className="text-xl font-bold w-6/12">CartTotal</p>
            <div className="flex justify-between lg:space-x-4 w-6/12">
            <p className="text-xl font-bold">CartSubtotal</p>
            <p className="text-xl font-bold">{value}</p>
            </div>
        </div>
      
            {/* ***********Shipping Part */}

        <div className="flex flex-col md:flex-row lg:space-x-4 mt-4 pb-4 border-b-2 border-slate-300  ">
            <p className="text-xl  mr-8">Shipping</p>
            <div className="flex flex-col space-y-2">
            <div className="flex space-x-4 w-full border-b-2 pb-4 align-center border-slate-300">
                <input type="checkbox" className=" bg-tradr-green mr-2 h-6 w-6 border-none outline-none focus:outline-none " />
                     <p className="text-xl ">Flat Rate: #20000</p>
               </div>
               {/* addreess */}
               <div className="flex flex-col w-full">
               <p className="text-xl block">Shipping to <span className="font-bold">Lagos</span></p>
               <p className="text-xl md:border-b-4 md:border-black font-bold cursor-pointer "
               onClick={() => setChangeAddress(!changeAddress)}> Change Address </p>
                {
                    changeAddress && (
                        <div className="flex flex-col w-full mt-2">
                         <div className="w-full pb-2  border-ash border-b mb-4">  
                         <select name="country" className="text-xl w-full bg-inherit" 
                         style={{backgroundColor:"inherit", outline:"none", border:"none", width:"100%"}}
                         >
                    <option value="volvo">Nigeria</option>
                     <option value="saab">Ghana</option>
                     <option value="opel">Kenya</option>
                      <option value="audi">Cameroun</option>
                        </select>     
                            </div>
                         <div className="w-full pb-2  border-ash border-b mb-4">  
                         <select name="country" className="text-xl w-full bg-inherit" 
                         style={{backgroundColor:"inherit", outline:"none", border:"none", width:"100%"}}
                         >
                    <option value="volvo">Lagos</option>
                     <option value="saab">Ogun</option>
                     <option value="opel">Calabar</option>
                      <option value="audi">Kwara</option>
                        </select>     
                            </div>
                         <div className="w-full pb-2  border-ash border-b mb-4">  
                         <select name="country" className="text-xl w-full bg-inherit" 
                         style={{backgroundColor:"inherit", outline:"none", border:"none", width:"100%"}}
                         >
                    <option value="volvo">Ikeja</option>
                     <option value="saab">Abeokuta</option>
                     <option value="opel">Edo</option>
                      <option value="audi">Ilorin</option>
                        </select>     
                            </div>
                         <div className="w-full pb-2  border-ash border-b mb-4">  
                        <input type="text" placeholder="No 12 ibrahim str" className="w-full"
                       style={{backgroundColor:"inherit", outline:"none", border:"none", width:"100%"}}  />
                            </div>
                            <button  className="btn block bg-tradr-green text-white font-normal py-2 px-4  uppercase mb-4 rounded-sm">
                        Update
              </button>
                            </div>
                    )
                }

               </div> 
               </div> 

    </div>
    {/* ***********End of Shipping Part */}
    {/* ****************Total value */}
    <div className="flex md:justify-end mt-4  ">
    <div className="flex flex-col space-y-4 lg:w-5/12">
        <div className="flex justify-between lg:space-x-4 w-full">
            <p className="text-xl ">Total</p>
            <p className="text-xl font-bold">{value}</p>
            </div>
            <Link to="/all-products" className="btn bg-tradr-green text-white font-normal py-2 px-4  uppercase mb-4">
              Proceed to Checkout
              </Link>
            </div>
        </div>
    </div>
)

}

export default CartTotal        